import { render } from "./DropDownMultiple.vue?vue&type=template&id=0098c017&scoped=true&ts=true"
import script from "./DropDownMultiple.vue?vue&type=script&lang=ts"
export * from "./DropDownMultiple.vue?vue&type=script&lang=ts"

import "./DropDownMultiple.vue?vue&type=style&index=0&id=0098c017&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0098c017"]])

export default __exports__